import { ReactNode } from 'react';

import { ExpenseCategory } from '@components/templates/expense/category/expense-category.tsx';
// import { Brands } from '@components/templates/products/brand/brands';
import { CreateNewSale } from '@components/templates/sales/create.sale/create-sale';
import { RolePermissionList } from '@components/templates/users/role.permission.list/role-permission.list';

import { Dashboard } from '@/components/templates/dashboard/dashboard';
import { Expense } from '@/components/templates/expense/expense';
// import { Generics } from '@/components/templates/products/generic/generics';
import { CreateProduct } from '@/components/templates/products/products/create.product/create-product';
// import { ProductList } from '@/components/templates/products/products/products';
// import { Strength } from '@/components/templates/products/strength/strength';
// import { Types } from '@/components/templates/products/type/types';
// import { Units } from '@/components/templates/products/unit/units';
import { CreateStock } from '@/components/templates/stocks/create.stock/creare-stock';
// import { CreateUser } from '@/components/templates/users/create.user/create-user';
import { Route } from '@/constants';
import { BalanceSheet } from '@/modules/accounting/balance-sheet';
import { ProfitAndLoss } from '@/modules/accounting/profit-and-loss';
import { Transactions } from '@/modules/accounting/transactions';
import {
    CreateExpiredStockAdjustment,
    CreateStockAdjustment,
    ExpiredStockAdjustmentDetails,
    ExpiredStockAdjustmentList,
    StockAdjustmentList,
} from '@/modules/adjustment';
import { Cart } from '@/modules/cart';
import { CustomerDetails, CustomerList } from '@/modules/customers';
import { NotificationList } from '@/modules/notification';
import {
    BrandList,
    CreateProduct as CreateProductNew,
    GenericList,
    ProductList,
    StrengthList,
    TypeList,
    UnitList,
} from '@/modules/products';
import {
    CreatePurchaseReturn, // CreatePurchaseV2,
    PurchaseDetails,
    PurchaseList,
    PurchaseReturnDetails,
    PurchaseReturnList,
} from '@/modules/purchase';
import {
    CreatePrePurchase,
    PrePurchaseDetails,
    PrePurchaseList,
} from '@/modules/purchase/pre-purchase';
import {
    ReportActivity,
    ReportCustomer,
    ReportDaily,
    ReportExpense,
    ReportProfitAndLoss,
    ReportPurchase,
    ReportPurchasePayment,
    ReportRegister,
    ReportSale,
    ReportSalePayment,
    ReportStock,
    ReportStockAdjustment,
    ReportSupplier,
    ReportTransaction,
} from '@/modules/reports';
import { OrderDetails, OrderList } from '@/modules/sales';
import {
    CreateSalesReturn,
    SalesReturnDetails,
    SalesReturnList,
} from '@/modules/sales-return';
import { InvoiceSettings } from '@/modules/settings';
import {
    ExpiredStockList,
    LowStockList,
    StockList,
    StockOutList,
} from '@/modules/stocks';
import { StockProductDetails } from '@/modules/stocks/stock-product-details';
import { SupplierDetails, SupplierList } from '@/modules/suppliers';
// import { UserList } from '@/components/templates/users/userList/user-list';
import { CreateUser, EditUser, UserDetails, UserList } from '@/modules/users';
import {
    WholesaleCustomerDetails,
    WholesaleOrderCustomers,
    WholesaleOrderDetails,
    WholesaleOrderRequestDetails,
    WholesaleOrderRequests,
} from '@/modules/wholesale-orders';

import { CashBox } from '../../modules/cash-box';
import { publicRoutes as authPublicRoutes } from './public-route.config';

type RouteType = {
    key: string;
    path: string;
    component: ReactNode;
    authority: string[];
};

export const publicRoutes: RouteType[] = [...authPublicRoutes];
export const protectedRoutes: RouteType[] = [
    {
        key: Route.DASHBOARD,
        path: Route.DASHBOARD,
        component: <Dashboard />,
        authority: [],
    },
    {
        key: Route.PRODUCTS,
        path: Route.PRODUCTS,
        component: <ProductList />,
        authority: ['products__read'],
    },
    {
        key: Route.PRODUCT_CREATE_NEW,
        path: Route.PRODUCT_CREATE_NEW,
        component: <CreateProductNew />,
        authority: ['products__read'],
    },
    {
        key: Route.PRODUCT_BRANDS,
        path: Route.PRODUCT_BRANDS,
        component: <BrandList />,
        authority: ['products__read'],
    },
    {
        key: Route.PRODUCT_UNITS,
        path: Route.PRODUCT_UNITS,
        component: <UnitList />,
        authority: ['products__read'],
    },
    {
        key: Route.PRODUCTS,
        path: Route.PRODUCT_CREATE,
        component: <CreateProduct />,
        authority: ['products__create'],
    },
    {
        key: Route.STOCK_ALL_PRODUCTS,
        path: Route.STOCK_ALL_PRODUCTS,
        component: <StockList />,
        authority: [],
    },
    {
        key: Route.STOCK_ADD,
        path: Route.STOCK_ADD,
        component: <CreateStock />,
        authority: [],
    },

    {
        key: Route.STOCK_PRODUCT_DETAILS,
        path: Route.STOCK_PRODUCT_DETAILS,
        component: <StockProductDetails />,
        authority: [],
    },

    {
        key: Route.USERS,
        path: Route.USERS,
        component: <UserList />,
        authority: [],
    },
    {
        key: Route.USER_CREATE,
        path: Route.USER_CREATE,
        component: <CreateUser />,
        authority: [],
    },

    {
        key: Route.USER_DETAILS,
        path: Route.USER_DETAILS,
        component: <UserDetails />,
        authority: [],
    },

    {
        key: Route.USER_EDIT,
        path: Route.USER_EDIT,
        component: <EditUser />,
        authority: [],
    },

    {
        key: Route.ROLES,
        path: Route.ROLES,
        component: <RolePermissionList />,
        authority: [],
    },
    {
        key: Route.SUPPLIERS,
        path: Route.SUPPLIERS,
        component: <SupplierList />,
        authority: [],
    },
    {
        key: Route.SUPPLIER_DETAILS,
        path: Route.SUPPLIER_DETAILS,
        component: <SupplierDetails />,
        authority: [],
    },
    {
        key: Route.CUSTOMERS,
        path: Route.CUSTOMERS,
        component: <CustomerList />,
        authority: [],
    },
    {
        key: Route.CUSTOMER_DETAILS,
        path: Route.CUSTOMER_DETAILS,
        component: <CustomerDetails />,
        authority: [],
    },
    {
        key: Route.POS,
        path: Route.POS,
        component: <CreateNewSale />,
        authority: [],
    },
    {
        key: Route.POS_NEW,
        path: Route.POS_NEW,
        component: <Cart />,
        authority: [],
    },
    {
        key: Route.SALES,
        path: Route.SALES,
        component: <OrderList />,
        authority: [],
    },

    {
        key: Route.SALE_DETAILS,
        path: Route.SALE_DETAILS,
        component: <OrderDetails />,
        authority: [],
    },

    {
        key: Route.PURCHASES,
        path: Route.PURCHASES,
        component: <PurchaseList />,
        authority: [],
    },

    {
        key: Route.PURCHASE_CREATE,
        path: Route.PURCHASE_CREATE,
        component: <CreateStock />,
        authority: [],
    },

    // {
    //     key: Route.PURCHASE_CREATE_NEW,
    //     path: Route.PURCHASE_CREATE_NEW,
    //     component: <CreatePurchaseV2 />,
    //     authority: [],
    // },

    {
        key: Route.PURCHASE_DETAILS,
        path: Route.PURCHASE_DETAILS,
        component: <PurchaseDetails />,
        authority: [],
    },

    {
        key: Route.PURCHASE_RETURNS,
        path: Route.PURCHASE_RETURNS,
        component: <PurchaseReturnList />,
        authority: [],
    },

    {
        key: Route.PURCHASE_RETURN_CREATE,
        path: Route.PURCHASE_RETURN_CREATE,
        component: <CreatePurchaseReturn />,
        authority: [],
    },

    {
        key: Route.PURCHASE_RETURN_DETAILS,
        path: Route.PURCHASE_RETURN_DETAILS,
        component: <PurchaseReturnDetails />,
        authority: [],
    },

    {
        key: Route.PRE_PURCHASES,
        path: Route.PRE_PURCHASES,
        component: <PrePurchaseList />,
        authority: [],
    },

    {
        key: Route.PRE_PURCHASE_CREATE,
        path: Route.PRE_PURCHASE_CREATE,
        component: <CreatePrePurchase />,
        authority: [],
    },

    {
        key: Route.PRE_PURCHASE_DETAILS,
        path: Route.PRE_PURCHASE_DETAILS,
        component: <PrePurchaseDetails />,
        authority: [],
    },

    {
        key: Route.STOCK_LOW_PRODUCTS,
        path: Route.STOCK_LOW_PRODUCTS,
        component: <LowStockList />,
        authority: [],
    },
    {
        key: Route.STOCK_OUT_PRODUCTS,
        path: Route.STOCK_OUT_PRODUCTS,
        component: <StockOutList />,
        authority: [],
    },
    {
        key: Route.STOCK_EXPIRED_PRODUCTS,
        path: Route.STOCK_EXPIRED_PRODUCTS,
        component: <ExpiredStockList />,
        authority: [],
    },
    {
        key: Route.PRODUCT_TYPES,
        path: Route.PRODUCT_TYPES,
        component: <TypeList />,
        authority: [],
    },
    {
        key: Route.PRODUCT_STRENGTHS,
        path: Route.PRODUCT_STRENGTHS,
        component: <StrengthList />,
        authority: [],
    },
    {
        key: Route.PRODUCT_GENERICS,
        path: Route.PRODUCT_GENERICS,
        component: <GenericList />,
        authority: [],
    },
    {
        key: Route.REPORTS_CUSTOMERS,
        path: Route.REPORTS_CUSTOMERS,
        component: <ReportCustomer />,
        authority: [],
    },
    {
        key: Route.REPORTS_SUPPLIERS,
        path: Route.REPORTS_SUPPLIERS,
        component: <ReportSupplier />,
        authority: [],
    },
    {
        key: Route.REPORTS_SALES,
        path: Route.REPORTS_SALES,
        component: <ReportSale />,
        authority: [],
    },
    // {
    //     key: Route.REPORTS_PURCHASE,
    //     path: Route.REPORTS_PURCHASE,
    //     component: <PurchaseReport />,
    //     authority: [],
    // },

    // {
    //   key: 'product-reports',
    //   path: Route.REPORTS_PRODUCTS,
    //   component: <ProductReports />,
    //   authority: [],
    // },

    {
        key: Route.EXPENSES,
        path: Route.EXPENSES,
        component: <Expense />,
        authority: [],
    },

    {
        key: Route.EXPENSE_CATEGORIES,
        path: Route.EXPENSE_CATEGORIES,
        component: <ExpenseCategory />,
        authority: [],
    },

    {
        key: Route.ACCOUNTING_TRANSACTIONS,
        path: Route.ACCOUNTING_TRANSACTIONS,
        component: <Transactions />,
        authority: [],
    },

    {
        key: Route.ACCOUNTING_PROFIT_AND_LOSS,
        path: Route.ACCOUNTING_PROFIT_AND_LOSS,
        component: <ProfitAndLoss />,
        authority: [],
    },

    {
        key: Route.ACCOUNTING_BALANCE_SHEET,
        path: Route.ACCOUNTING_BALANCE_SHEET,
        component: <BalanceSheet />,
        authority: [],
    },

    // Wholesale Orders
    {
        key: Route.WHOLESALE_ORDER_REQUESTS,
        path: Route.WHOLESALE_ORDER_REQUESTS,
        component: <WholesaleOrderRequests />,
        authority: ['wholesale__read'],
    },

    {
        key: Route.WHOLESALE_ORDER_REQUEST_DETAILS,
        path: Route.WHOLESALE_ORDER_REQUEST_DETAILS,
        component: <WholesaleOrderRequestDetails />,
        authority: ['wholesale__read'],
    },

    {
        key: Route.WHOLESALE_ORDER_CUSTOMERS,
        path: Route.WHOLESALE_ORDER_CUSTOMERS,
        component: <WholesaleOrderCustomers />,
        authority: ['wholesale__read'],
    },

    {
        key: Route.WHOLESALE_ORDER_CUSTOMER_DETAILS,
        path: Route.WHOLESALE_ORDER_CUSTOMER_DETAILS,
        component: <WholesaleCustomerDetails />,
        authority: ['wholesale__read'],
    },

    {
        key: Route.WHOLESALE_ORDER_DETAILS,
        path: Route.WHOLESALE_ORDER_DETAILS,
        component: <WholesaleOrderDetails />,
        authority: ['wholesale__read'],
    },
    {
        key: Route.SETTINGS_INVOICE,
        path: Route.SETTINGS_INVOICE,
        component: <InvoiceSettings />,
        authority: [],
    },

    // Notification
    {
        key: Route.NOTIFICATIONS,
        path: Route.NOTIFICATIONS,
        component: <NotificationList />,
        authority: [],
    },

    // Stock Adjustment

    // Expired Stock Adjustment
    {
        key: Route.ADJUSTMENT_EXPIRED_PRODUCTS,
        path: Route.ADJUSTMENT_EXPIRED_PRODUCTS,
        component: <ExpiredStockAdjustmentList />,
        authority: [],
    },

    {
        key: Route.ADJUSTMENT_EXPIRED_PRODUCT_CREATE,
        path: Route.ADJUSTMENT_EXPIRED_PRODUCT_CREATE,
        component: <CreateExpiredStockAdjustment />,
        authority: [],
    },

    {
        key: Route.ADJUSTMENT_EXPIRED_PRODUCT_DETAILS,
        path: Route.ADJUSTMENT_EXPIRED_PRODUCT_DETAILS,
        component: <ExpiredStockAdjustmentDetails />,
        authority: [],
    },

    // Normal Stock Adjustment
    {
        key: Route.ADJUSTMENT_STOCKS,
        path: Route.ADJUSTMENT_STOCKS,
        component: <StockAdjustmentList />,
        authority: [],
    },

    {
        key: Route.ADJUSTMENT_STOCK_CREATE,
        path: Route.ADJUSTMENT_STOCK_CREATE,
        component: <CreateStockAdjustment />,
        authority: [],
    },

    // Sales Return
    {
        key: Route.SALES_RETURNS,
        path: Route.SALES_RETURNS,
        component: <SalesReturnList />,
        authority: [],
    },

    {
        key: Route.SALES_RETURN_CREATE,
        path: Route.SALES_RETURN_CREATE,
        component: <CreateSalesReturn />,
        authority: [],
    },

    {
        key: Route.SALES_RETURN_DETAILS,
        path: Route.SALES_RETURN_DETAILS,
        component: <SalesReturnDetails />,
        authority: [],
    },

    // Reports
    {
        key: Route.REPORTS_ALL_TRANSACTIONS,
        path: Route.REPORTS_ALL_TRANSACTIONS,
        component: <ReportTransaction />,
        authority: [],
    },

    {
        key: Route.REPORTS_ACTIVITY_LOGS,
        path: Route.REPORTS_ACTIVITY_LOGS,
        component: <ReportActivity />,
        authority: [],
    },
    {
        key: Route.REPORTS_DAILY,
        path: Route.REPORTS_DAILY,
        component: <ReportDaily />,
        authority: [],
    },
    {
        key: Route.REPORTS_PROFIT_AND_LOSS,
        path: Route.REPORTS_PROFIT_AND_LOSS,
        component: <ReportProfitAndLoss />,
        authority: [],
    },
    {
        key: Route.REPORTS_EXPENSE,
        path: Route.REPORTS_EXPENSE,
        component: <ReportExpense />,
        authority: [],
    },

    {
        key: Route.REPORTS_SALE_PAYMENT,
        path: Route.REPORTS_SALE_PAYMENT,
        component: <ReportSalePayment />,
        authority: [],
    },

    {
        key: Route.REPORTS_PURCHASE_PAYMENT,
        path: Route.REPORTS_PURCHASE_PAYMENT,
        component: <ReportPurchasePayment />,
        authority: [],
    },
    {
        key: Route.REPORTS_STOCK,
        path: Route.REPORTS_STOCK,
        component: <ReportStock />,
        authority: [],
    },

    {
        key: Route.CASH_BOX,
        path: Route.CASH_BOX,
        component: <CashBox />,
        authority: [],
    },

    {
        key: Route.REPORTS_STOCK_ADJUSTMENT,
        path: Route.REPORTS_STOCK_ADJUSTMENT,
        component: <ReportStockAdjustment />,
        authority: [],
    },

    {
        key: Route.REPORTS_CUSTOMERS,
        path: Route.REPORTS_CUSTOMERS,
        component: <ReportCustomer />,
        authority: [],
    },

    {
        key: Route.REPORTS_SUPPLIERS,
        path: Route.REPORTS_SUPPLIERS,
        component: <ReportSupplier />,
        authority: [],
    },

    {
        key: Route.REPORTS_PURCHASE,
        path: Route.REPORTS_PURCHASE,
        component: <ReportPurchase />,
        authority: [],
    },

    {
        key: Route.REPORTS_SALES,
        path: Route.REPORTS_SALES,
        component: <ReportSale />,
        authority: [],
    },

    {
        key: Route.REPORTS_REGISTER,
        path: Route.REPORTS_REGISTER,
        component: <ReportRegister />,
        authority: [],
    },
];
